import {isInBrowser} from './common';

let i18nDebug: boolean | undefined;

export function isI18nDebugEnabled(): boolean {
  if (i18nDebug !== undefined) {
    return i18nDebug;
  }
  i18nDebug =
    isInBrowser() &&
    new URLSearchParams(window.location.search).get('debug') === 'i18n';
  return i18nDebug;
}
